const layout = {
  exit: 'Log out',
  welcome1: 'Hi, there~ Welcome to Jarvis Botlab Platform,',
  welcome2: "we're so glad you're here!"
}

export default layout
